import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { SettingsService } from './settings.service';

@Injectable({providedIn: 'root'})
export class UtilitiesService {
    constructor(
        private translateService: TranslateService,
        private settingsService: SettingsService
    ) {}

    // Get translations for weekdays
    getWeekDaysTranslations(weekday?: string): any[] {

        if (weekday) {
            return this.translateService.instant('generic.weekday_' + weekday.toLowerCase());
        }

        return [
            {
                weekday: 'monday',
                translation: this.translateService.instant('generic.weekday_monday'),
            },
            {
                weekday: 'tuesday',
                translation: this.translateService.instant('generic.weekday_tuesday'),
            },
            {
                weekday: 'wednesday',
                translation: this.translateService.instant('generic.weekday_wednesday'),
            },
            {
                weekday: 'thursday',
                translation: this.translateService.instant('generic.weekday_thursday'),
            },
            {
                weekday: 'friday',
                translation: this.translateService.instant('generic.weekday_friday'),
            },
            {
                weekday: 'saturday',
                translation: this.translateService.instant('generic.weekday_saturday'),
            },
            {
                weekday: 'sunday',
                translation: this.translateService.instant('generic.weekday_sunday')
            },
        ];
    }

    sortObjectArrayByProperty<T>(array: T[], sortyByProperty: string, ascending: boolean = true, userLocale: boolean = true): T[] {
        let sortedArray: any;

        if (userLocale) {
            let localeCode: string;

            this.settingsService.get().subscribe((settings) => {

                localeCode = settings.languageCode;

                if (ascending) {
                    sortedArray = array.sort((a: any, b: any) => (a[sortyByProperty].localeCompare(b[sortyByProperty], localeCode)));
                } else {
                    sortedArray = array.sort((a: any, b: any) => (b[sortyByProperty].localeCompare(a[sortyByProperty], localeCode)));
                }
            });

        } else {
            if (ascending) {
                sortedArray = array.sort((a: any, b: any) => (a[sortyByProperty] > b[sortyByProperty]) ? 1 : -1);
            } else {
                sortedArray = array.sort((a: any, b: any) => (a[sortyByProperty] < b[sortyByProperty]) ? 1 : -1);
            }
        }

        return sortedArray;
    }
}